import { render, staticRenderFns } from "./cost-table.vue?vue&type=template&id=548214b4&scoped=true"
import script from "./cost-table.vue?vue&type=script&lang=js"
export * from "./cost-table.vue?vue&type=script&lang=js"
import style0 from "./cost-table.vue?vue&type=style&index=0&id=548214b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548214b4",
  null
  
)

export default component.exports